export type StaffGroup = 'managing' | 'coaching';
export type ManagingStaffPositoin = '部長' | '会長' | '代表' | 'HP担当';
export type CoachingStaffPosition = '監督' | '背番号コーチ' | 'コーチ(事務局)' | 'コーチ(チーム審判)' | 'コーチ'; 

export type BaseStaff = {
    id: number;
    name: string;
}

export type ManagingStaff = BaseStaff & {
    position: ManagingStaffPositoin;
}

export type CoarchingStaff = BaseStaff & {
    position: CoachingStaffPosition;
}

export type StaffState = {
    group: StaffGroup;
    managing: ManagingStaff[];
    coaching: CoarchingStaff[];
}

export const INITIAL_STATE: StaffState = {
    group: 'managing',
    managing: [],
    coaching: []
}
